import Swal from "sweetalert2";

let sessionExpirationPromise;

const closeSession = () => {
    localStorage.clear();
    window.location.href = "/login";
};

export const handleSessionExpiration = async (axios) => {
    if (sessionExpirationPromise) {
        return sessionExpirationPromise;
    }

    sessionExpirationPromise = (async () => {
        const result = await Swal.fire({
            title: "Tu sesión ha expirado.",
            text: "¿Deseas continuar con la sesión?",
            icon: "question",
            showCancelButton: true,
            confirmButtonText: "Sí, continuar",
            cancelButtonText: "No, cerrar sesión",
            confirmButtonColor: "#4A001F",
            cancelButtonColor: "#f0a6b7",
            customClass: {
                actions: "my-actions",
                cancelButton: "swal2-cancel",
                confirmButton: "order-2",
            },
        });

        if (!result.isConfirmed) {
            closeSession();
            return null;
        }

        try {
            const token = localStorage.getItem("token");
            if (!token) {
                throw new Error("No hay un token disponible para renovar la sesión.");
            }

            const response = await axios.post(
                `${process.env.REACT_APP_URLAPI}/refreshToken`,
                null,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "application/json",
                    },
                    skipSessionExpiration: true,
                }
            );

            const newToken = response.data?.token;
            if (!newToken) {
                throw new Error("La respuesta de renovación no contiene un token.");
            }

            localStorage.setItem("token", newToken);
            axios.defaults.headers.common.Authorization = `Bearer ${newToken}`;
            return newToken;
        } catch {
            await Swal.fire({
                icon: "error",
                title: "Error al actualizar la sesión",
                text: "Por favor, inicie sesión nuevamente.",
                showConfirmButton: true,
                confirmButtonColor: "#4A001F",
            });
            closeSession();
            return null;
        }
    })();

    try {
        return await sessionExpirationPromise;
    } finally {
        sessionExpirationPromise = null;
    }
};
